import SingleEditor from './SingleEditor'

export default SingleEditor
